import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	edit: {
		id: 'navigation-apps-shortcuts-sidebar.shortcut.edit',
		defaultMessage: 'Edit shortcut',
		description: 'Edit button for shortcut',
	},
	editWithShortcutText: {
		id: 'navigation-apps-shortcuts-sidebar.shortcut.edit-with-shortcut-text',
		defaultMessage: 'Edit shortcut for {shortcutText}',
		description: 'Aria-label for edit shortcut button if shortcutText is not empty',
	},
	sync: {
		id: 'navigation-apps-shortcuts-sidebar.shortcut.sync',
		defaultMessage: 'Sync',
		description: 'Sync button for shortcut',
	},
});
